import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const Monitor = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className='lucide lucide-monitor-icon lucide-monitor'
      >
        <rect width='20' height='14' x='2' y='3' rx='2' />
        <line x1='8' x2='16' y1='21' y2='21' />
        <line x1='12' x2='12' y1='17' y2='21' />
      </svg>
    </SvgIcon>
  );
};

export default Monitor;
